<template>
  <b-tab title="ข้อมูลส่วนตัว" active>
    <b-row>
      <b-col lg="12" class="my-2">
        <h4 class="text-muted">ข้อมูลเบื้องต้น</h4>
      </b-col>
      <b-col cols="6">
        <ValidationProvider rules="required|email" v-slot="{ errors }">
          <b-form-group label="Username">
            <b-form-input
              v-model="driverDetails.email"
              :state="!errors.length ? null : false"></b-form-input>
            <b-form-invalid-feedback>
              {{ errors[0] }}
            </b-form-invalid-feedback>
          </b-form-group>
        </ValidationProvider>
      </b-col>
      <b-col cols="6">
        <b-form-group label="Password">
          <b-form-input
            type="password"
            v-model="driverDetails.password"></b-form-input>
        </b-form-group>
      </b-col>
      <b-col cols="6">
        <b-form-group label="เงินค้ำประกัน">
          <b-form-input v-model="driverDetails.guarantee_money"></b-form-input>
        </b-form-group>
        <!-- เงินค้ำประกัน แบบมี validate -->
        <!-- <ValidationProvider rules="required" v-slot="{ errors }">
                    <b-form-group label="เงินค้ำประกัน">
                        <b-form-input
                            v-model="driverDetails.guarantee_money"
                            :state="!errors.length ? null : false"
                        ></b-form-input>
                        <b-form-invalid-feedback>
                            {{ errors[0] }}
                        </b-form-invalid-feedback>
                    </b-form-group>
                </ValidationProvider> -->
      </b-col>
      <b-col cols="6">
        <b-form-group label="เริ่มหักวันที่">
          <b-form-datepicker
            v-model="driverDetails.start_date"
            class="mb-2"
            locale="th"></b-form-datepicker>
        </b-form-group>
        <!-- เริ่มหักวันที่ แบบมี validate -->
        <!-- <ValidationProvider rules="required" v-slot="{ errors }">
          <b-form-group label="เริ่มหักวันที่">
            <b-form-datepicker
              v-model="driverDetails.start_date"
              class="mb-2"
              locale="th"
              :state="!errors.length ? null : false"></b-form-datepicker>
            <b-form-invalid-feedback>
              {{ errors[0] }}
            </b-form-invalid-feedback>
          </b-form-group>
        </ValidationProvider> -->
      </b-col>
    </b-row>
    <hr class="my-2" />
    <b-row>
      <b-col lg="12" class="my-2">
        <h4 class="text-muted">ข้อมูลส่วนตัว</h4>
      </b-col>
      <b-col cols="6">
        <b-form-group label="ชื่อ">
          <b-form-input v-model="driverDetails.firstname"></b-form-input>
        </b-form-group>
      </b-col>
      <b-col cols="6">
        <b-form-group label="นามสกุล">
          <b-form-input v-model="driverDetails.lastname"></b-form-input>
        </b-form-group>
      </b-col>
      <b-col cols="6">
        <b-form-group label="Email">
          <b-form-input v-model="driverDetails.email"></b-form-input>
        </b-form-group>
      </b-col>
      <b-col cols="6">
        <b-form-group label="เบอร์โทรศัพท์">
          <b-form-input v-model="driverDetails.phonenumber"></b-form-input>
        </b-form-group>
      </b-col>
      <b-col cols="6">
        <b-form-group label="ที่อยู่">
          <b-form-input v-model="driverDetails.address"></b-form-input>
        </b-form-group>
      </b-col>
      <b-col cols="6">
        <b-form-group label="แขวง/ตำบล">
          <b-form-input v-model="driverDetails.sub_district"></b-form-input>
        </b-form-group>
      </b-col>
      <b-col cols="4">
        <b-form-group label="เขต/อำเภอ">
          <b-form-input v-model="driverDetails.district"></b-form-input>
        </b-form-group>
      </b-col>
      <b-col cols="4">
        <b-form-group label="จังหวัด">
          <b-form-input v-model="driverDetails.province"></b-form-input>
        </b-form-group>
      </b-col>
      <b-col cols="4">
        <b-form-group label="รหัสไปรษณีย์">
          <b-form-input v-model="driverDetails.postal_code"></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <hr class="my-3" />
    <b-row>
      <b-col lg="12" class="my-2">
        <h4 class="text-muted">ข้อมูลใบขับขี่</h4>
      </b-col>
      <b-col cols="6">
        <ValidationProvider rules="required" v-slot="{ errors }">
          <b-form-group label="ประเภทใบขับขี่">
            <b-form-input
              v-model="driverDetails.driverLicenses.license_type"
              :state="!errors.length ? null : false"></b-form-input>
            <b-form-invalid-feedback>
              {{ errors[0] }}
            </b-form-invalid-feedback>
          </b-form-group>
        </ValidationProvider>
      </b-col>
      <b-col cols="6">
        <ValidationProvider rules="required" v-slot="{ errors }">
          <b-form-group label="เลขที่ใบขับขี่">
            <b-form-input
              v-model="driverDetails.driverLicenses.license_number"
              :state="!errors.length ? null : false"></b-form-input>
            <b-form-invalid-feedback>
              {{ errors[0] }}
            </b-form-invalid-feedback>
          </b-form-group>
        </ValidationProvider>
      </b-col>
      <b-col cols="6">
        <ValidationProvider rules="required" v-slot="{ errors }">
          <b-form-group label="วันอนุญาติ">
            <b-form-datepicker
              v-model="driverDetails.driverLicenses.license_start_date"
              class="mb-2"
              locale="th"
              :state="!errors.length ? null : false"></b-form-datepicker>
            <b-form-invalid-feedback>
              {{ errors[0] }}
            </b-form-invalid-feedback>
          </b-form-group>
        </ValidationProvider>
      </b-col>
      <b-col cols="6">
        <ValidationProvider rules="required" v-slot="{ errors }">
          <b-form-group label="วันสิ้นอายุ">
            <b-form-datepicker
              v-model="driverDetails.driverLicenses.license_end_date"
              class="mb-2"
              locale="th"
              :state="!errors.length ? null : false"></b-form-datepicker>
            <b-form-invalid-feedback>
              {{ errors[0] }}
            </b-form-invalid-feedback>
          </b-form-group>
        </ValidationProvider>
      </b-col>
    </b-row>
  </b-tab>
</template>

<script>
import { ValidationProvider } from "vee-validate";
export default {
  props: {
    driverDetails: {
      type: Object,
    },
  },
  components: {
    ValidationProvider,
  },
};
</script>
